import { render, staticRenderFns } from "./DxAttachmentMonthlyTable.vue?vue&type=template&id=8dc752c8&"
import script from "./DxAttachmentMonthlyTable.vue?vue&type=script&lang=js&"
export * from "./DxAttachmentMonthlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports